export default __webpack_public_path__ + "static/media/play_store.e5980b98.png";